import { titleRepositorySingleton } from '@warehouse/title/infra';
import { useWatchObservableQuery } from '@warehouse/shared/util';

export const useSearchRelationshipChildren = (uuid?: string) => {
	const repo = titleRepositorySingleton.get();
	return useWatchObservableQuery({
		queryKey: ['search-children-relationships', uuid],
		queryFn: () => (uuid ? repo.watchChildrenRelationshipsTypes(uuid) : null),
	});
};
